module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Edmondson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Laura Edmondson is Associate Professor and Chair of the Department of Theater at Dartmouth College, where she is also affiliated with African and African American Studies. She is author of "), _c('I', [_vm._v("Performance and Politics in Tanzania: The Nation on Stage")]), _vm._v(" (IUP).")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sHRNQg/tc-custom/9780253035509.jpg?1738254646458",
      "alt": "This image is the cover for the book Performing Trauma in Central Africa, African Expressive Cultures"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Performing Trauma in Central Africa, African Expressive Cultures\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“An outstanding addition to the literature on theatre and performance in situations of conflict and post-conflict.” —"), _c('i', [_vm._v("New Theatre Quarterly")])]), _c('br'), _c('br'), _vm._v("What are the stakes of cultural production in a time of war? How is artistic expression prone to manipulation by the state and international humanitarian organizations? In the charged political terrain of post-genocide Rwanda, post-civil war Uganda, and recent violence in the Democratic Republic of Congo, Laura Edmondson explores performance through the lens of empire."), _c('br'), _c('br'), _vm._v("Instead of celebrating theatre productions as expression of cultural agency and resilience, Edmondson traces their humanitarian imperatives to a place where global narratives of violence take precedence over local traditions and audiences. Working at the intersection of performance and trauma, Edmondson reveals how artists and cultural workers manipulate narratives in the shadow of empire and how empire, in turn, infiltrates creative capacities.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0